// src/components/photo/VideoUpload.jsx

import React, { useRef } from 'react';

const VideoUpload = ({ onVideoUpload }) => {
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('video/')) {
      onVideoUpload(file);
    } else {
      alert('Please upload a valid video file.');
    }
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-md border border-gray-200 text-center">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">
        Upload a Video
      </h2>
      <p className="text-gray-600 mb-4">
        Select a video file to analyze your pose.
      </p>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept="video/*"
        className="hidden"
      />
      <button
        onClick={() => fileInputRef.current.click()}
        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors"
      >
        Choose Video
      </button>
    </div>
  );
};

export default VideoUpload;